import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  MUSIC_OPTIONS,
  setFocusSessionActive,
  setMusicEnabled,
  setSelectedTrack,
  setSessionDuration,
  setSessionStartTime,
  setSessionView,
  setSubject,
} from "../../store/ProductivitySessionSlice";
import { Button, FormControlLabel } from "@mui/material";
import "./CreateSession.css";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../../../ControlPanel/components/AddEvent/Dropdown/CustomDropdown";
import IOSSwitch from "../../../../components/IOSSwitch";

function useMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

export default function CreateSession() {
  const dispatch = useDispatch();
  const { sessionView, subject, sessionDuration, isMusicEnabled, selectedTrack } = useSelector(
    (state) => state.productivitySession
  );
  const { currentRoom } = useSelector((state) => state.MapDisplay);
  const { t } = useTranslation();

  const isMobile = useMobile();

  const [isExpanded, setIsExpanded] = useState(false);

  const [showDurationError, setShowDurationError] = useState(false);

  const beginSession = () => {
    if (!sessionDuration || sessionDuration === "0") {

      setShowDurationError(true);
      return; 
    }      
    dispatch(setFocusSessionActive(true));
    dispatch(setSessionStartTime(Date.now()));
    dispatch(setSessionView("progress"));
    
  };

  useEffect(() => {
    if (sessionView === "create") {
      setIsExpanded(false);
    }
  }, [sessionView]);

  const handleClose = () => {
    setIsExpanded(false);
  };

  const renderSessionModal = () => (
    <div className="coffe-pause-overlay-create" onClick={() => setIsExpanded(false)}>
        <div className="coffe-pause-modal-centered" onClick={(e) => e.stopPropagation()}>
          <div className="session-header">
            <div className="session-header-left">
              <span className="material-symbols-outlined session-header-icon">
                headphones
              </span>
              <div className="session-header-title">
                <span className="session-header-title-text">
                  {t("productivity_session")}
                </span>
                <span className="session-room-name">{currentRoom?.label}</span>
              </div>
            </div>
            <div className="session-header-right">
              <Button className="close-button" onClick={handleClose}
              style={{ padding: "0", margin: "0",maxWidth: "1.875rem", width: "1.875rem",minWidth: "1.25rem"}}>
                <span className="material-symbols-outlined">close</span>
              </Button>
            </div>
          </div>
          <div className="session-content">
            <span className="session-content-text">
              {t("productivity_session_description")}
            </span>
            <div className="session-content-form">
              <div className="session-inputs">
                <label className="session-inputs-label">
                  {t("session_subject_opt")}
                </label>
                <input
                  className="session-inputs-input"
                  type="text"
                  value={subject}
                  onChange={(e) => dispatch(setSubject(e.target.value))}
                  placeholder={t("enter_session_subject")}
                />
              </div>
              <div className="session-inputs" style={{ position: "relative" }}>
                <label className="session-inputs-label">{t("duration")}</label>
                <div
                  className="session-inputs-input"
                  style={{
                    
                    position: "relative",
                    border: showDurationError ? "1px solid #d32f2f" : "", 
                  }}
                >
                  <CustomDropdown
                    options={[
                      { value: "15", label: `15 ${t("minutes")}` },
                      { value: "30", label: `30 ${t("minutes")}` },
                      { value: "45", label: `45 ${t("minutes")}` },
                      { value: "60", label: `1 ${t("hour")}` },
                      { value: "75", label: `1h 15 ${t("minutes")}` },
                      { value: "90", label: `1h 30 ${t("minutes")}` },
                      { value: "105", label: `1h 45 ${t("minutes")}` },
                      { value: "120", label: `2 ${t("hours")}` },
                    ]}
                    value={sessionDuration}
                    onChange={(val) => {
                      dispatch(setSessionDuration(val));
                      if (val) setShowDurationError(false);
                    }}
                    placeholder={t("select_duration")}
                    width="100%"
                    showIcon={false}
                  />
                </div>
              </div>
              <div className="session-music-toggle-row" >
                <FormControlLabel
                  className="session-music-toggle"
                  label={
                    <span>
                      {t("back_noise")}
                    </span>
                  }
                  labelPlacement="end"
                  control={
                    <IOSSwitch
                      className={isMusicEnabled ? 'switch-active-green' : 'switch-inactive-red'}
                      checked={isMusicEnabled}
                      onChange={(e) => dispatch(setMusicEnabled(!isMusicEnabled))}
                    />
                  }
                />
              </div>
              {isMusicEnabled && (
                <div className="music-selection-section">
                  <div className="music-grid">
                    {MUSIC_OPTIONS.map((track) => (
                      <button
                        key={track.id}
                        type="button"
                        className={`music-grid-btn ${selectedTrack === track.id ? 'active' : ''}`}
                        onClick={() => dispatch(setSelectedTrack(track.id))}
                      >
                        <div
                          className="icon-wrapper"
                          style={{ backgroundColor: track.back }}
                        >
                          <span
                            className="material-symbols-outlined music-icon"
                            style={{ color: track.color, display: 'block' }}
                          >
                            {track.icon}
                          </span>
                        </div>
                        <span className="music-btn-label">{t(track.name)}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}


            </div>
            <div className="session-button-container">
              <button
                type="button"
                className="session-button"
                onClick={() => {
                  beginSession();
                }}
              >
                {t("begin_session")}
              </button>
            </div>
          </div>
      </div>
    </div>
  );


  if (!sessionView || sessionView === "progress") {
    return null;
  }

  if (sessionView === "create") {
return (

  <>
       
        <div
          className={`session-fab-container ${isMobile ? 'mobile-pos' : ''}`}
          onClick={() => setIsExpanded(true)
          }            >
          <div className="session-fab-circle">
            <span className="material-symbols-outlined session-fab-icon">
              headphones
            </span>
          </div>
        </div>
      
  {isExpanded && isMobile &&(
           
      
        <div className="mobile-popup-overlay" style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
          display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}
          onClick={() => setIsExpanded(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            {renderSessionModal()}
          </div>
        </div>
  )}
    {isExpanded && !isMobile &&(
        renderSessionModal() )}
    </>
    )
  }
  
}
